import { SelectedMarkerV2 } from 'components/site/general/singleSelect/SelectedMarkerV2';
import { IWorldMarker, isV2Marker } from 'react-give-me-map';

interface Props {
    singleSelectedMarker: IWorldMarker;
    controlsRef: React.MutableRefObject<HTMLDivElement[]>;
}

export const DisplaySelectedMarker = (props: Props): JSX.Element => {
    const { singleSelectedMarker } = props;

    return (
        <>
            {isV2Marker(singleSelectedMarker) && (
                <SelectedMarkerV2 markerId={singleSelectedMarker.id} />
            )}
        </>
    );
};
